import BarclaysSrc from "src/assets/banks/Barclays.svg";
import RevolutSrc from "src/assets/banks/Revolut.svg";
import MonzoSrc from "src/assets/banks/Monzo.svg";
import StarlingSrc from "src/assets/banks/Starling.svg";
import SantanderSrc from "src/assets/banks/Santander.svg";
import NatwestSrc from "src/assets/banks/NatWest.svg";
import RbsSrc from "src/assets/banks/RBS.svg";
import ChaseSrc from "src/assets/banks/Chase.svg";
import BankOfScotlandSrc from "src/assets/banks/BankOfScotland.svg";
import LloydsSrc from "src/assets/banks/Lloyds.svg";
import FirstDirectSrc from "src/assets/banks/FirstDirect.svg";
import HSBCSrc from "src/assets/banks/HSBC.svg";
import HalifaxSrc from "src/assets/banks/Halifax.svg";
import BankOfIrelandSrc from "src/assets/banks/BankOfIreland.svg";
import DanskeBankSrc from "src/assets/banks/DanskeBank.svg";
import AibSrc from "src/assets/banks/AIB.svg";
import TsbSrc from "src/assets/banks/TSB.svg";
import TideSrc from "src/assets/banks/Tide.svg";
import TescoSrc from "src/assets/banks/Tesco.svg";
import CouttsSrc from "src/assets/banks/Coutts.png";
import UlsterBankSrc from "src/assets/banks/UlsterBank.svg";
import NationwideSrc from "src/assets/banks/Nationwide.svg";
import WiseSrc from "src/assets/banks/Wise.png";
import VirginSrc from "src/assets/banks/VirginMoney.png";
import GiraffeSrc from "src/assets/banks/giraffe.svg";
import BankNotFoundSrc from "src/assets/BankNotFound.svg";

const productionLocalSources = [
    {
        name: "Revolut",
        id: "revolut",
        type: "INSTITUTION",
        logo: RevolutSrc,
    },
    {
        name: "Monzo",
        id: "monzo",
        type: "INSTITUTION",
        logo: MonzoSrc,
    },
    {
        name: "Starling Bank",
        id: "starling",
        type: "INSTITUTION",
        logo: StarlingSrc,
    },
    {
        name: "Barclays",
        id: "barclays",
        type: "INSTITUTION",
        logo: BarclaysSrc,
    },
    {
        name: "Santander",
        id: "santander_uk",
        type: "INSTITUTION",
        logo: SantanderSrc,
    },
    {
        name: "Natwest",
        id: "natwest",
        type: "INSTITUTION",
        logo: NatwestSrc,
    },
    {
        name: "Royal Bank of Scotland",
        id: "rbs",
        type: "INSTITUTION",
        logo: RbsSrc,
    },
    {
        name: "Chase",
        id: "chase_uk",
        type: "INSTITUTION",
        logo: ChaseSrc,
    },
    {
        name: "Bank of Scotland",
        id: "bankofscotland",
        type: "INSTITUTION",
        logo: BankOfScotlandSrc,
    },
    {
        name: "Lloyds",
        id: "lloyds",
        type: "INSTITUTION",
        logo: LloydsSrc,
    },
    {
        name: "First Direct",
        id: "firstdirect",
        type: "INSTITUTION",
        logo: FirstDirectSrc,
    },
    {
        name: "HSBC",
        id: "hsbc_uk",
        type: "INSTITUTION",
        logo: HSBCSrc,
    },
    {
        name: "Halifax",
        id: "halifax",
        type: "INSTITUTION",
        logo: HalifaxSrc,
    },
    {
        name: "Bank of Ireland UK",
        id: "bankofireland_uk",
        type: "INSTITUTION",
        logo: BankOfIrelandSrc,
    },
    {
        name: "Danske Bank",
        id: "danskebank_uk",
        type: "INSTITUTION",
        logo: DanskeBankSrc,
    },
    {
        name: "AIB NI",
        id: "firsttrustbank",
        type: "INSTITUTION",
        logo: AibSrc,
    },
    {
        name: "TSB",
        id: "tsb",
        type: "INSTITUTION",
        logo: TsbSrc,
    },
    {
        name: "Tide",
        id: "tide",
        type: "INSTITUTION",
        logo: TideSrc,
    },
    {
        name: "Tesco Bank",
        id: "tescobank",
        type: "INSTITUTION",
        logo: TescoSrc,
    },
    {
        name: "Coutts",
        id: "coutts",
        type: "INSTITUTION",
        logo: CouttsSrc,
    },
    {
        name: "Ulster Bank",
        id: "ulsterbank_uk",
        type: "INSTITUTION",
        logo: UlsterBankSrc,
    },
    {
        name: "Wise",
        id: "wise-live",
        type: "INSTITUTION",
        logo: WiseSrc,
    },
    {
        name: "Nationwide",
        id: "nationwide",
        type: "INSTITUTION",
        logo: NationwideSrc,
    },
    {
        name: "Virgin Money",
        id: "virginmoney",
        type: "INSTITUTION",
        logo: VirginSrc,
    },
    {
        name: "GBank",
        id: "gbank",
        type: "INSTITUTION",
        logo: GiraffeSrc,
    },
];

export const ibanLocalSource = [
    {
        name: "Revolut",
        id: "revolut",
        type: "INSTITUTION",
        logo: RevolutSrc,
    },
    {
        name: "Barclays",
        id: "barclays",
        type: "INSTITUTION",
        logo: BarclaysSrc,
    },
    {
        name: "First Direct",
        id: "firstdirect",
        type: "INSTITUTION",
        logo: FirstDirectSrc,
    },
    {
        name: "HSBC",
        id: "hsbc_uk",
        type: "INSTITUTION",
        logo: HSBCSrc,
    },
    {
        name: "Danske Bank",
        id: "danskebank_uk",
        type: "INSTITUTION",
        logo: DanskeBankSrc,
    },
    {
        name: "AIB UK - First Trust Bank",
        id: "firsttrustbank",
        type: "INSTITUTION",
        logo: AibSrc,
    },
    {
        name: "Coutts & Company",
        id: "coutts",
        type: "INSTITUTION",
        logo: CouttsSrc,
    },
    {
        name: "Wise",
        id: "wise-live",
        type: "INSTITUTION",
        logo: WiseSrc,
    },
];

const developmentLocalSources = [
    {
        name: "Giraffe",
        id: "giraffe",
        type: "INSTITUTION",
        logo: GiraffeSrc,
    },
    {
        name: "GBank",
        id: "gbank",
        type: "INSTITUTION",
        logo: GiraffeSrc,
    },
];

export const localSources =
    process.env.REACT_APP_STAGE === "production"
        ? productionLocalSources
        : developmentLocalSources;
